import script from "./CardModificarReserva.vue?vue&type=script&setup=true&lang=js"
export * from "./CardModificarReserva.vue?vue&type=script&setup=true&lang=js"

import "./CardModificarReserva.vue?vue&type=style&index=0&id=4c7aca78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7aca78"]])

export default __exports__